import request from '@/plugin/axios'

export function createGoods (data) {
  return request({
    url: '/api/admin/createGoods',
    method: 'post',
    data: data
  })
}
export function goodsList (data) {
  return request({
    url: '/api/admin/goodsList',
    method: 'get',
    params: data
  })
}
export function modifyGoods (data) {
  return request({
    url: '/api/admin/modifyGoods',
    method: 'post',
    data: data
  })
}

export function deleteGoods (data) {
  return request({
    url: '/api/admin/deleteGoods',
    method: 'post',
    data: data
  })
}
export function auditReq (data) {
  return request({
    url: '/api/admin/auditReq',
    method: 'post',
    data: data
  })
}
export function optShelt (data) {
  return request({
    url: '/api/admin/optShelt',
    method: 'post',
    data: data
  })
}
export function goodsCategoryOption () {
  return request({
    url: '/api/admin/goodsCategoryOption',
    method: 'get'
  })
}
export function goodStateList (data) {
  return request({
    url: '/api/admin/goodStateList',
    method: 'get',
    params: data
  })
}
export function queryMemberDayTimeList () {
  return request({
    url: '/api/admin/queryMemberDayTimeList',
    method: 'get'
  })
}
export function orderStatistics (data) {
  return request({
    url: '/api/admin/orderStatistics',
    method: 'get',
    params: data
  })
}
export function queryMemberDayTimeDetailList (data) {
  return request({
    url: '/api/admin/queryMemberDayTimeDetailList',
    method: 'get',
    params: data
  })
}
export function queryWeekDayList (data) {
  return request({
    url: '/api/admin/queryWeekDayList',
    method: 'get',
    params: data
  })
}
export function addMemberDayTime (data) {
  return request({
    url: '/api/admin/addMemberDayTime',
    method: 'post',
    data: data
  })
}
export function updateMemberDayTime (data) {
  return request({
    url: '/api/admin/updateMemberDayTime',
    method: 'post',
    data: data
  })
}
export function deleteMemberDayDetail (data) {
  return request({
    url: '/api/admin/deleteMemberDayDetail',
    method: 'post',
    data: data
  })
}
export function changeGoodsOrd (data) {
  return request({
    url: '/api/admin/changeGoodsOrd',
    method: 'post',
    data: data
  })
}
